import { tx as translateInterfaceText } from '@/utils/i18n';
import { authApi } from './authService';

interface CreateInvoicePayload {
  quantity: number;
  id_Stripe_Card: string;
  request_id: string;
}
export interface AutoRechargeConfig {
  enabled: boolean;
  quantity: number;
  id_Stripe_Card: string | null;
  processing: boolean;
  last_error: string | null;
}
interface ApiResult<T> {
  success: boolean;
  message?: string;
  retryable?: boolean;
  data?: T;
}
interface PurchaseResult {
  invoice_id: string;
  quantity: number;
  total_cents: number;
  credited: boolean;
}
function failure<T>(error: unknown, fallback: string): ApiResult<T> {
  const response = (error as { response?: { data?: ApiResult<T> } })?.response?.data;
  if (response?.success === false && typeof response.message === 'string') return response;
  return { success: false, message: fallback, retryable: true };
}
export const invoiceService = {
  createInvoiceAndPay: async (customer: string, payload: CreateInvoicePayload): Promise<ApiResult<PurchaseResult>> => {
    try {
      return (await authApi.post(`/invoice/${customer}`, payload)).data;
    } catch (error) {
      return failure(error, 'Não foi possível confirmar a compra. Tente novamente para consultar a mesma tentativa.');
    }
  },
  getAutoRecharge: async (customer: string): Promise<ApiResult<AutoRechargeConfig>> => {
    try {
      return (await authApi.get(`/clicks-per-plan/${customer}`)).data;
    } catch (error) {
      return failure(error, 'Não foi possível carregar a recarga automática. Tente novamente.');
    }
  },
  resumeAutoRecharge: async (customer: string): Promise<ApiResult<AutoRechargeConfig>> => {
    try {
      return (await authApi.post(`/clicks-per-plan/${customer}/recharge`)).data;
    } catch (error) {
      return failure(error, 'Não foi possível confirmar a recarga automática. Consulte a mesma tentativa novamente.');
    }
  },
  setAutoRecharge: async (customer: string, payload: { buyAutomatic: boolean; quantity?: number; id_Stripe_Card?: string }): Promise<ApiResult<AutoRechargeConfig>> => {
    try {
      return (await authApi.patch(`/clicks-per-plan/${customer}`, payload)).data;
    } catch (error) {
      return failure(error, 'Não foi possível salvar a recarga automática. Tente novamente.');
    }
  },
};
export default invoiceService;
